import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false;

import i18n from './i18n'

import moment from 'moment';
import 'moment/locale/zh-cn';
moment.locale('zh-cn');
Vue.prototype.$moment = moment;
import "quill/dist/quill.core.css"

import vueinfinitescroll from 'vue-infinite-scroll'
Vue.use(vueinfinitescroll)

import AntD from 'ant-design-vue';
import 'ant-design-vue/dist/antd.less';
Vue.use(AntD);

import VueClipboard from 'vue-clipboard2';
Vue.use(VueClipboard);

//Dolphin
import Dolphin from 'dolphin-framework-vue'
import DolphinConfig from './components/DolphinConfig'
import DolphinAntD from './components/Dolphin-ant-design-erp'
Vue.use(Dolphin);
Vue.use(DolphinConfig);
Vue.use(DolphinAntD);

//common js
import config from './components/config'
import './assets/scss/common.scss'
Vue.use(config);


Vue.prototype.$kt = function (str,strEn,strRu) {
  let lang = localStorage.getItem('lang');
  if(lang === 'en'){
    return strEn || str+ '_ENG';
  }else if (lang === 'ru'){
    return strRu || str+ '_RUS';
  }else {
    return str;
  }
}

const socketConfig = Vue.prototype.$Dolphin.socket;
import VueSocketIo from 'vue-socket.io';
if(socketConfig && socketConfig.open){
  Vue.use(new VueSocketIo(socketConfig));
}

import CONSTANT from './components/constant';
Vue.prototype.$constant = CONSTANT;

window.$DolAntPage = new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app');
